import { Workbook } from 'exceljs';
import { Event } from 'inscreva-sse-models';
import { Subscription } from 'inscreva-sse-models/dist/models/subscription';
import moment from 'moment';

export class SubscriptionsExport {
  static async export(subscriptions: Subscription[], event: Event) {
    const dateFileName = moment().format('DD-MM-YYYY');
    const eventName = event.info.name.toLowerCase().replace(/ +/g, '-');
    const filename = `${eventName}_${dateFileName}.xlsx`;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Inscritos');

    workbook.creator = 'Inscreva-SSe - SS Parisi';
    workbook.created = workbook.modified = new Date();
    worksheet.columns = [
      { header: 'Nome', key: 'name', width: 32 },
      { header: 'Email', key: 'email', width: 62 },
      { header: 'Data', key: 'date', width: 62 },
      { header: 'Cidade', key: 'city', width: 62 },
    ];

    worksheet.addRows(
      subscriptions.map((subscription) => ({
        name: subscription.nome,
        email: subscription.email,
        date: subscription.createdAt,
        city: subscription.cidade,
      })),
    );
    const buffer = await workbook.xlsx.writeBuffer();

    return {
      buffer,
      filename,
    };
  }
}
